import { ShopOutlined } from '@ant-design/icons';
import { PlatformDomain, findAllPlatformDomain } from '../../apis/mgmt/api';
import { DataOptionProps, DataSelect, DataFormItem, DataSelectFormItemProps, DataSelectProps, ValueFormItemProps } from '../common/DataSelect';
import { FormItemProps, SelectProps } from 'antd';
import { useMemo } from 'react';

export const PlatformDomainOptionProps: DataOptionProps<PlatformDomain> = {
    labelFromData: (data) => data?.slug,
    labelToData: (label, data?: PlatformDomain) => {
        if (!data) data = {};
        data.slug = label;
        return data;
    },
}

const defaultSearch = async (text: string, filter?: { domainId?: string, platformId?: string }) => {
    //if (!filter || !filter.platformId || !filter.domainId) return [];
    const result = await findAllPlatformDomain({ ...filter, size: 100 });
    return result.data.content || [];
}

const PlatformDomainSelectBase = function<TFilter>(props: DataSelectProps<PlatformDomain,TFilter>) {
    return (
        <DataSelect<PlatformDomain,TFilter>
            placeholder="Dominio dentro de la plataforma"
            suffixIcon={<ShopOutlined className="site-form-item-icon" />}
            dataOptionsProps={PlatformDomainOptionProps}
            {...props}
        />
    );
}

export const PlatformDomainSelect = (props: 
    SelectProps<any> & { 
        selected?: PlatformDomain | PlatformDomain[],
        domainId?: string, platformId?: string 
    }
) => {

    const { domainId, platformId, ...selectProps } = props;
    const searchFilter = useMemo(() => ({ domainId, platformId }), [domainId, platformId]);
    
    return (
        <PlatformDomainSelectBase
            {...selectProps}
            search={defaultSearch}
            searchFilter={searchFilter}
        />
    );
}

export const PlatformDomainFormItem = (props: FormItemProps<any>) => 
    <DataFormItem<PlatformDomain>
        {...props}
        dataOptionsProps={PlatformDomainOptionProps}
    />
;